import { render, staticRenderFns } from "./InfoAudioComponent.vue?vue&type=template&id=1d6befa1&scoped=true&"
import script from "./InfoAudioComponent.vue?vue&type=script&lang=js&"
export * from "./InfoAudioComponent.vue?vue&type=script&lang=js&"
import style0 from "./InfoAudioComponent.vue?vue&type=style&index=0&id=1d6befa1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6befa1",
  null
  
)

export default component.exports